function boundRaf(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(callback);
  });
}

/**
 * 全局下拉框组件类
 */
class GlobalSelectComponent {
  constructor() {
    this.MAX_DROPDOWN_HEIGHT = 200;
    this.container = null;
    this.activeId = null;
    this.selects = {};
  }

  init() {
    this.createGlobalContainer();
    this.collectAllSelects();
    this.bindEvents();
  }

  createGlobalContainer() {
    this.container = document.getElementById('global-select-options');
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.id = 'global-select-options';
      // 使用 absolute + 文档滚动偏移进行定位，避免“跟随 body 而不是当前 select” 的问题
      this.container.style.cssText = 'position: absolute; top: 0; left: 0; z-index: 1000; pointer-events: none;';
      document.body.appendChild(this.container);
    }
    return this.container;
  }

  ensureContainer() {
    var container = document.getElementById('global-select-options');
    if (!container || !document.body.contains(container)) {
      this.createGlobalContainer();
    } else {
      this.container = container;
    }
    return this.container;
  }

  collectAllSelects() {
    var self = this;
    this.ensureContainer();

    var triggers = document.querySelectorAll('[data-dropdown-trigger]');

    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      var id = trigger.getAttribute('data-dropdown-trigger');
      var dropdown = document.querySelector('[data-dropdown-content="' + id + '"]');

      if (dropdown) {
        // 只要之前记录的 trigger 已经不在 DOM 中，就允许用新的 trigger/dropdown 覆盖
        var exists = this.selects[id];
        var shouldReplace = !exists || (exists.trigger && !document.body.contains(exists.trigger));

        if (shouldReplace) {
          if (exists && exists.dropdown && exists.dropdown.parentNode === this.container) {
            this.container.removeChild(exists.dropdown);
          }

          this.selects[id] = {
            trigger: trigger,
            dropdown: dropdown,
          };
        }

        if (!trigger._globalSelectBound) {
          trigger.addEventListener('click', function onTriggerClick(e) {
            e.stopPropagation();
            var clickedId = this.getAttribute('data-dropdown-trigger');
            self.toggle(clickedId);
          });
          trigger._globalSelectBound = true;
        }
        var optionsList = dropdown.querySelector('.select-options-list');
        if (optionsList) {
          var optionItems = optionsList.querySelectorAll('.select-options-item');

          for (var j = 0; j < optionItems.length; j++) {
            (function bindOption(item, dropdownId, triggerElement) {
              if (!item._globalSelectBound) {
                item.addEventListener('click', function onOptionClick(e) {
                  e.stopPropagation();
                  if (!item.hasAttribute('disabled')) {
                    self.close(dropdownId);
                  }

                  var itemData = self.getDataAttributes(item);
                  var componentType = triggerElement.getAttribute('data-component') || '';

                  var eventData = {
                    item: item,
                    data: itemData,
                    dropdownId: dropdownId,
                    trigger: triggerElement,
                    componentType: componentType,
                  };

                  var event = new CustomEvent('global-select:option-click', {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true,
                  });
                  document.dispatchEvent(event);
                });
                item._globalSelectBound = true;
              }
            })(optionItems[j], id, trigger);
          }
        }
      }
    }
  }

  /**
   * 绑定全局事件
   */
  bindEvents() {
    var self = this;

    document.addEventListener('click', function onDocumentClick(e) {
      if (self.activeId && !e.target.closest('[data-dropdown-content]')) {
        self.close(self.activeId);
      }
    });

    // 滚动 / resize 时，根据当前下拉框行为决定是“跟随”还是“关闭”
    const cartDrawer = document.querySelector('cart-drawer');
    cartDrawer?.addEventListener(
      'scroll',
      function onCartDrawerScroll() {
        if (!self.activeId) return;
        var select = self.selects[self.activeId];
        if (!select) return;
        var behavior = select.trigger.getAttribute('data-dropdown-behavior') || 'close'; // follow / close
        if (behavior === 'follow') {
          self.updatePosition(self.activeId);
        } else {
          self.close(self.activeId);
        }
      },
      true
    );

    window.addEventListener(
      'scroll',
      function onWindowScroll() {
        if (!self.activeId) return;
        var select = self.selects[self.activeId];
        if (!select) return;
        var behavior = select.trigger.getAttribute('data-dropdown-behavior') || 'close';
        if (behavior === 'follow') {
          self.updatePosition(self.activeId);
        } else {
          self.close(self.activeId);
        }
      },
      true
    );

    window.addEventListener('resize', function onResize() {
      if (!self.activeId) return;
      var select = self.selects[self.activeId];
      if (!select) return;
      var behavior = select.trigger.getAttribute('data-dropdown-behavior') || 'close';
      if (behavior === 'follow') {
        self.updatePosition(self.activeId);
      } else {
        self.close(self.activeId);
      }
    });

    document.addEventListener('cart:updated', function onCartUpdated() {
      setTimeout(function () {
        self.scan();
      }, 30);
    });

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function onMutations(mutations) {
        var shouldScan = false;
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-dropdown-trigger]')) {
              shouldScan = true;
              break;
            }
          }
          if (shouldScan) break;
        }
        if (shouldScan) {
          setTimeout(function () {
            self.scan();
          }, 10);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  /**
   * 切换下拉框
   */
  toggle(id) {
    if (this.activeId === id) {
      this.close(id);
    } else {
      if (this.activeId) {
        this.close(this.activeId);
      }
      this.open(id);
    }
  }

  /**
   * 打开下拉框
   */
  open(id) {
    console.log('打开');

    var select = this.selects[id];
    if (!select) return;

    this.activeId = id;
    this.ensureContainer();
    if (select.dropdown.parentNode !== this.container) {
      this.container.appendChild(select.dropdown);
    }
    this.updatePosition(id);

    var dropdown = select.dropdown;
    var isUpward = select.isUpward || false;

    dropdown.style.maxHeight = this.MAX_DROPDOWN_HEIGHT + 'px';
    dropdown.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
    dropdown.style.transform = 'scaleY(0)';
    dropdown.style.opacity = '0';
    dropdown.style.pointerEvents = 'auto';

    boundRaf(function () {
      dropdown.style.transform = 'scaleY(1)';
      dropdown.style.opacity = '1';
    });

    var arrow = select.trigger.querySelector('.arrow-icon');
    if (arrow) {
      arrow.style.transform = 'rotate(180deg)';
    }
  }

  /**
   * 关闭下拉框
   */
  close(id) {
    var select = this.selects[id];
    if (!select) return;

    this.activeId = null;

    var dropdown = select.dropdown;
    dropdown.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
    dropdown.style.transform = 'scaleY(0)';
    dropdown.style.opacity = '0';
    dropdown.style.pointerEvents = 'none';

    setTimeout(function () {
      dropdown.style.maxHeight = '0';
    }, 200);

    var arrow = select.trigger.querySelector('.arrow-icon');
    if (arrow) {
      arrow.style.transform = 'rotate(0deg)';
    }
  }

  /**
   * 更新下拉框位置
   */
  updatePosition(id) {
    var select = this.selects[id];
    if (!select) return;

    var trigger = select.trigger;
    var dropdown = select.dropdown;

    var rect = trigger.getBoundingClientRect();
    var gap = 4;

    var scrollX = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    var optionsList = dropdown.querySelector('.select-options-list');
    var actualContentHeight = optionsList ? optionsList.scrollHeight : 0;
    var dropdownHeight = Math.min(actualContentHeight, this.MAX_DROPDOWN_HEIGHT);

    if (dropdownHeight < 40 && actualContentHeight > 0) {
      dropdownHeight = actualContentHeight;
    }

    var top = rect.bottom + gap + scrollY;
    var left = rect.left + scrollX;
    var width = rect.width;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var spaceBelow = viewportHeight - rect.bottom;
    var spaceAbove = rect.top;

    var isUpward = false;
    if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
      top = rect.top - dropdownHeight - gap - 8;
      isUpward = true;
    }

    select.isUpward = isUpward;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (left + width > viewportWidth) {
      left = viewportWidth - width - 10;
    }

    dropdown.style.position = 'absolute';
    dropdown.style.top = top + 'px';
    dropdown.style.left = left + 'px';
    dropdown.style.width = width + 'px';
    dropdown.style.minWidth = width + 'px';

    if (isUpward) {
      dropdown.style.transformOrigin = 'bottom';
    } else {
      dropdown.style.transformOrigin = 'top';
    }
  }

  /**
   * 扫描新添加的下拉框（用于动态内容）
   */
  scan() {
    this.collectAllSelects();
  }

  /**
   * 获取元素的所有 data-* 属性
   * @param {HTMLElement} element - DOM 元素
   * @returns {Object} 包含所有 data-* 属性的对象
   */
  getDataAttributes(element) {
    var data = {};
    var attributes = element.attributes;

    for (var i = 0; i < attributes.length; i++) {
      var attr = attributes[i];
      if (attr.name.indexOf('data-') === 0) {
        var key = attr.name.substring(5).replace(/-([a-z])/g, function (match, letter) {
          return letter.toUpperCase();
        });
        data[key] = attr.value;
      }
    }

    return data;
  }
}

var GlobalSelectManager = new GlobalSelectComponent();
window.GlobalSelectManager = GlobalSelectManager;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function onReady() {
    GlobalSelectManager.init();
    setTimeout(function () {
      GlobalSelectManager.scan();
    }, 10);
  });
} else {
  GlobalSelectManager.init();
  setTimeout(function () {
    GlobalSelectManager.scan();
  }, 10);
}
